import React from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Quote } from '../../../../models/quote.model';
import { Order } from '../../../../models/order.model';
import { Invoice } from '../../../../models/invoice.model';
import { TaxDetail } from '../../../../models/tax.detail.model';
import { formatMoney, formatTaxRate } from '../../../../scripts/format.value.script';
import { ForeignCurrency } from '../../../../models/currency.model';
import { dateFormat } from '../../../../scripts/date.time.format.script';

export interface AppSaleViewAmountProps {
  sale: string,
  record: any | Quote | Order | Invoice
};

const AppSaleViewAmount: React.FunctionComponent<AppSaleViewAmountProps> = ({sale, record}) => {
  const {lang} = StateLanguage()
  const fc: ForeignCurrency | null = record.foreign_currency ?? null

  return (
    <div className="card card-flush mb-5">
      <div className="card-header">
        <div className="card-title">
          <h4>{lang.labels.amount}</h4>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="d-flex justify-content-end">
          <div className="mw-500px">
            <div className="d-flex flex-stack px-5 py-2 bg-light-info border-top border-bottom">
              <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.subTotal}:</div>
              <div className="text-end fw-bolder ps-20">
                {record.currency?.code ?? ''} {formatMoney(record.amount?.sub_total ?? 0)}
                {fc && <span className="text-muted fs-8 ms-2">| {fc?.code ?? ''} {formatMoney(fc.amount?.sub_total ?? 0)}</span>}
              </div>
            </div>
            <div className="d-flex flex-stack px-5 py-2 bg-light-info border-bottom">
              <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.rebateTotal}:</div>
              <div className="text-end fw-bolder ps-20">{record.currency?.code ?? ''} {formatMoney(record.amount?.rebate_total ?? 0)}</div>
            </div>
            <div className="d-flex flex-stack px-5 py-2 bg-light-info border-bottom">
              <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.taxTotal}:</div>
              <div className="text-end fw-bolder ps-20">
                {record.currency?.code ?? ''} {formatMoney(record.amount?.tax_total ?? 0)}
                {fc && <span className="text-muted fs-8 ms-2">| {fc?.code ?? ''} {formatMoney(fc.amount?.tax_total ?? 0)}</span>}
              </div>
            </div>
            { (record.amount?.tax_list ?? []).map (( (item: TaxDetail, index: number) => { return (
              <div key={index} className="d-flex flex-stack ps-10 pe-5 py-1 bg-light-dark">
                <div className="fw-bold pe-20 text-secondary fs-8">{lang.labels.tax}: {formatTaxRate(item.tax_rate)} %</div>
                <div className="text-end fw-bolder ps-20 fs-7">{record.currency?.code ?? ''} {formatMoney(item.tax_value)}</div>
              </div>
            )}))}
            { sale === "invoice" && (record.reminders ?? []).length > 0 &&
              <div className="d-flex flex-stack px-5 py-2 bg-light-info border-bottom">
                <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.reminderTotal}:</div>
                <div className="text-end fw-bolder ps-20">{record.currency?.code ?? ''} {formatMoney(record.amount?.reminder_total ?? 0)}</div>
              </div>
            }
            <div className="d-flex flex-stack px-5 py-2 bg-light-warning border-top border-bottom">
              <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.total}:</div>
              <div className="text-end fw-bolder ps-20">
                {record.currency?.code ?? ''} {formatMoney(record.amount?.total ?? 0)}
                {fc && <span className="text-muted fs-8 ms-2">| {fc?.code ?? ''} {formatMoney(fc.amount?.total ?? 0)}</span>}
              </div>
            </div>
            { sale === "invoice" &&
              <>
                <div className="d-flex flex-stack px-5 py-2 bg-light-success border-top border-bottom">
                  <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.payed}:</div>
                  <div className="text-end fw-bolder ps-20">{record.currency?.code ?? ''} {formatMoney(record.amount?.paid ?? 0)}</div>
                </div>
                <div className="d-flex flex-stack px-5 py-2 bg-light-danger border-top border-bottom">
                  <div className="fw-bold pe-20 text-secondary fs-7">{lang.labels.debt}:</div>
                  <div className="text-end fw-bolder ps-20">{record.currency?.code ?? ''} {formatMoney(record.amount?.debt ?? 0)}</div>
                </div>
              </>
            }
            { fc &&
              <div className="d-flex flex-stack px-5 py-2 bg-light border-bottom">
                <div className="fw-bold text-secondary fs-8">{lang.labels.rateInfo}:</div>
                <div className="text-end fw-bold text-muted fs-8">1 {record.currency?.code ?? ''} = {fc.exchange_rate} {fc.code ?? ''} ({fc.exchange_date ? dateFormat(lang.code, fc.exchange_date) : ''})</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppSaleViewAmount;